import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
//import doctorphoto from "./../assets/images/sir.png";

const RightSideForm = () =>{
	const navigate = useNavigate();

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [message, setMessage] = useState("");

	/*const [formDataState, setFormDataState] = useState({
    	name: "",
    	email: "",
    	phone: "",
    	//findUs: "",
    	message: "",
    	//date: minDate,
  	});*/

  	const handleName = (e) =>{

  		setName(e.target.value);
  	}

  	const handleEmail = (e) =>{

  		setEmail(e.target.value);
  	}

  	const handlePhone = (e) =>{
  		console.log(':::' + e);
  		setPhone(e);
  	}

  	const handleMessage = (e) =>{

  		setMessage(e.target.value);
  	}

  const [status, setStatus] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  /*const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };*/

const sendEmail = async (e) => {    
	e.preventDefault();

	setIsSubmit(true);

      // Prepare FormData object
	const formData = new FormData();
	formData.append("name", name);
	formData.append("email", email);
	formData.append("phone", phone);
	//formData.append("findUs", formDataState.findUs);
	formData.append("message", message);
	//formData.append("date", formDataState.date);

	//console.log('Form Data====' + JSON.stringify(formData));
	//return false;

    try 
    {
      	const response = await axios.post("https://entdelhi.com/mailer/mailer.php", formData);
      	if (response.data.success) 
      	{
        	setStatus("Message sent successfully!");
        	// Reset form state
        	setName("");
        	setEmail("");
        	setPhone("");
        	setMessage("");
	        /*setFormDataState({
	          name: "",
	          email: "",
	          phone: "",
	          //findUs: "",
	          message: "",
	        });*/

        	navigate("/thank-you");
      	} 
      	else 
      	{
        	setStatus("Failed to send message.");
        	console.error(response.data.error);
      	}
      	setIsSubmit(false);
    } 
    catch (error) 
    {
      	setStatus("Something went wrong!");
      	console.error("Axios error:", error);
    }
};
  	return (
    <div>
      	<section className="pq-contact-us form-map" style={{ bottom: "50px" }}>
        	<div className="container mt-5">
				<div class="row g-4">

					<div class="col-md-12">
						<div class="form-section">
							<h4 class="mb-3" style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>Appointment with  Dr. (Major) Rajesh Bhardwaj</h4>
							<form onSubmit={sendEmail}>

								<div class="mb-3">
									<input type="text" class="form-control" placeholder="Patients Name" name="name" required value={name} onChange={handleName} />
								</div>

								<div class="mb-3">
									<input type="email" class="form-control" placeholder="Enter your email" name="email" required value={email} onChange={handleEmail} />
								</div>

								<div class="mb-3">
									{/*<input id="phone" type="tel" class="form-control" placeholder="Your Phone Number" name="phone" required value={formDataState.phone} onChange={handleChange} maxLength="13" onInput={(e) => {
										e.target.value = e.target.value.replace(/\D/g, "");
									}} />*/}

                    					<PhoneInput country={'in'} value={phone} onChange={handlePhone} maxLength="13" placeholder="Your Phone Number" name="phone" id="phone" required />
								</div>

								<div class="mb-3">
									<textarea id="message" class="form-control" name="message" rows="3" cols="40" placeholder="Describe Your Problems" value={message} onChange={handleMessage}></textarea>

								</div>

								<div className="mb-2">
									<div className="form-check">									
										<input class="form-check-input" type="checkbox" id="policy" required />
										<label className="form-check-label" htmlFor="policy">
										I agree to the terms in the <Link to="">Privacy Policy</Link>
										</label>
									</div>
									<div class="form-check">
										<input class="form-check-input" type="checkbox" id="offers" required />
										<label class="form-check-label" htmlFor="offers">
											I would like MedFirst ENT Centre to send me information about ENT solutions, services and offers.
										</label>
									</div>
								</div>
								{/*<button type="submit" class="btn btn-submit mt-2">Book Appointment Now</button>*/}

								{!isSubmit && <button type="submit" class="btn btn-submit mt-2">Book Appointment Now</button>}
								{isSubmit && 
									<button type="submit" class="btn btn-submit mt-2" disabled={true}>
										<div class="ms-4 spinner-border text-light" role="status">
											<span class="sr-only">Loading...</span>
										</div>
									</button>
								}
							</form>
						</div>
					</div>
				</div>
        	</div>
      	</section>
    </div>
  );

}

export default RightSideForm;